// extracted by mini-css-extract-plugin
export default {"imageWrapper":"CI-z","twoColumnImage":"DI-z"};